module.exports = __webpack_public_path__ + "../../static/vue/img/competition_512.5b6a15a4.jpg";